import React, { useCallback } from 'react';
import type { ICellRendererParams } from 'ag-grid-community';

import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import Tooltip from '@/components/mui/Tooltip';

const PreviewCellRenderer: React.FC<ICellRendererParams> = ({ data, context, colDef, api, node }) => {
  const { id } = data;

  const {
    components: {
      [colDef!.cellRenderer as string]: { onClickPreview, onClickPayment },
    },
  } = context;

  const handlePreviewClick = useCallback(() => {
    onClickPreview(id);

    // it is way hard row resetting allows us to avoid grid's scrolling during navigation preview by arrow keys
    api.redrawRows({ rowNodes: [node] });
  }, [onClickPreview, api, node, id]);

  const handleOpenPayment = useCallback(() => {
    onClickPayment(id);
  }, [onClickPayment, id]);

  return (
    <Stack flex={1} direction="row" justifyContent="center" alignItems="center">
      <Tooltip t={{ id: 'paymentWorkspace.grid.previewDocument', defaultMessage: 'Document preview' }}>
        <IconButton onClick={handlePreviewClick} color="primary" sx={{ fontSize: '22px' }}>
          <RemoveRedEyeOutlinedIcon fontSize="inherit" />
        </IconButton>
      </Tooltip>
      <Tooltip t={{ id: 'paymentWorkspace.grid.openPaymentForm', defaultMessage: 'Open payment form' }}>
        <IconButton onClick={handleOpenPayment} color="primary" sx={{ fontSize: '22px' }}>
          <InsertDriveFileOutlinedIcon fontSize="inherit" />
        </IconButton>
      </Tooltip>
    </Stack>
  );
};

export default PreviewCellRenderer;
